import { StreamChat } from 'stream-chat';
import Config from '../../../../config';

// Singleton chat client that is modified across our application.
export const chatClient = new StreamChat(Config.streamApiKey);
